import { Toggle as TogglePrimitive } from "@base-ui/react/toggle"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "@/modules/lib/utils"

const toggleVariants = cva(
  "group/toggle inline-flex items-center justify-center gap-1 rounded-3xl whitespace-nowrap transition-colors outline-none focus-visible:ring-[3px] disabled:pointer-events-none [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
  {
    variants: {
      variant: {
        emphasisLow: cn(
          "text-interactive-text-secondary-default",
          "hover:bg-interactive-background-neutral-highlighted",
          "disabled:text-interactive-text-secondary-disabled",
          "aria-pressed:bg-(--chip-bg-selected)",
          "aria-pressed:text-(--chip-text-selected)",
          "hover:aria-pressed:bg-interactive-background-neutral-highlighted",
          "hover:aria-pressed:text-interactive-text-secondary-default",
          "disabled:aria-pressed:bg-interactive-background-neutral-disabled",
          "disabled:aria-pressed:text-interactive-text-secondary-disabled",
        ),
        emphasisHigh: cn(
          "text-interactive-text-secondary-default",
          "hover:bg-interactive-background-neutral-highlighted",
          "disabled:text-interactive-text-secondary-disabled",
          "aria-pressed:bg-linear-to-r",
          "aria-pressed:from-interactive-background-primary-gradient-from",
          "aria-pressed:to-interactive-background-primary-gradient-to",
          "aria-pressed:text-interactive-text-primary-default",
          "hover:aria-pressed:from-interactive-background-primary-gradient-hover-from",
          "hover:aria-pressed:to-interactive-background-primary-gradient-hover-to",
          "disabled:aria-pressed:bg-none",
          "disabled:aria-pressed:bg-interactive-background-neutral-disabled",
          "disabled:aria-pressed:text-interactive-text-secondary-disabled",
        ),
      },
      size: {
        md: "h-10.5 w-29.5 body-medium has-data-[icon=inline-end]:pr-2 has-data-[icon=inline-start]:pl-2 aria-pressed:label-large",
        sm: "h-7 w-29.5 px-2.5 body-medium has-data-[icon=inline-end]:pr-1.5 has-data-[icon=inline-start]:pl-1.5 aria-pressed:label-medium [&_svg:not([class*='size-'])]:size-3.5",
        icon: "px-4 py-1",
      },
    },
    defaultVariants: {
      variant: "emphasisLow",
      size: "md",
    },
  },
)

function Toggle({
  className,
  variant = "emphasisLow",
  size = "md",
  ...props
}: TogglePrimitive.Props & VariantProps<typeof toggleVariants>) {
  return (
    <TogglePrimitive
      data-slot="toggle"
      className={cn(toggleVariants({ variant, size, className }))}
      {...props}
    />
  )
}

export { Toggle, toggleVariants }
